import Box from "@mui/material/Box";

import { useTranslation } from "react-i18next";
import StatisticsBox from "../../../../components/StatisticsBox";

const Boxes = ({ data }) => {
	const { t } = useTranslation();

	return (
		<Box sx={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
			<StatisticsBox
				title={t("cargos_entered")}
				value={data.entered}
				color="#000000"
			/>
			<StatisticsBox
				title={t("sent_to_stocks")}
				value={data.sentToStock}
				color="#7F7F7F"
			/>
			<StatisticsBox
				title={t("sent_mails_to_groups")}
				value={data.sentEmails}
				color="#7F7F7F"
			/>
			<StatisticsBox
				title={t("cargos_sold")}
				value={data.sold}
				color="#AE78D6"
			/>
			<StatisticsBox title="TIMOCOM" value={data.timocom} color="#0069B4" />
			<StatisticsBox
				title={t("total_margin") + " (€)"}
				value={data.margin}
				color="#92D050"
			/>
			<StatisticsBox title="TRANS" value={data.trans} color="#F07C00" />
			<StatisticsBox
				title={t("cargos_unsold")}
				value={data.notSold}
				color="#A6A6A6"
			/>
			<StatisticsBox title="TELEROUTE" value={data.teleroute} color="#FF9999" />
		</Box>
	);
};

export default Boxes;
